import ScalarHotkey_vue_vue_type_script_setup_true_lang_default from "./ScalarHotkey.vue.script.js";
//#region src/components/ScalarHotkey/ScalarHotkey.vue
var ScalarHotkey_default = ScalarHotkey_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarHotkey_default as default };

//# sourceMappingURL=ScalarHotkey.vue.js.map